import { render } from "./DownloadStudentIDCardsBanner.vue?vue&type=template&id=fe072538"
import script from "./DownloadStudentIDCardsBanner.vue?vue&type=script&lang=js"
export * from "./DownloadStudentIDCardsBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__